import type { EventsLeadContactsOrder } from '../types/events-management'
import type { ExhibitorCenterSectionId, ExhibitorEditSection, ExhibitorLeadsFilterSection } from '../types/exhibitor-center'

export const EXHIBITOR_CENTER_SECTION_IDS = ['overview', 'team', 'leads', 'export'] as const satisfies readonly ExhibitorCenterSectionId[]

/** Section the center lands on, and the fail-soft target for an absent or unknown `?tab`. */
export const EXHIBITOR_CENTER_DEFAULT_SECTION: ExhibitorCenterSectionId = 'overview'

export const EXHIBITOR_EDIT_SECTIONS = ['header', 'information', 'contact', 'social'] as const satisfies readonly ExhibitorEditSection[]

/** Shared by the description editor (which enforces it) and the drawer hint that counts against it. */
export const EXHIBITOR_DESCRIPTION_MAX_LENGTH = 600

/** Typing settles for this long before the leads search reaches the server. */
export const EXHIBITOR_LEADS_SEARCH_DEBOUNCE_MS = 300

/** Id prefix every leads element shares, so specs and QA selectors stay stable. */
export const EXHIBITOR_LEADS_ID_PREFIX = 'exhibitor-center-leads'

/** Shown in a leads cell with nothing to show. */
export const EXHIBITOR_LEADS_EMPTY_CELL = '—'

/** naive-ui's bottom drawer defaults to 251px; the member sheet needs room for a real team, the sort sheet only two rows. */
export const EXHIBITOR_LEADS_MEMBERS_DRAWER_HEIGHT = 'min(32rem, 80dvh)'
export const EXHIBITOR_LEADS_SORT_DRAWER_HEIGHT = '15rem'

/** The sheet a compact filter drawer shows before any chip has been tapped. */
export const EXHIBITOR_LEADS_DEFAULT_FILTER_SECTION: ExhibitorLeadsFilterSection = 'sort'

export const EXHIBITOR_LEADS_ORDER_OPTIONS = [
  { key: 'desc', labelKey: 'clientportal.events.detail.exhibitorCenterLeadsSortNewest' },
  { key: 'asc', labelKey: 'clientportal.events.detail.exhibitorCenterLeadsSortOldest' },
] as const satisfies readonly { key: EventsLeadContactsOrder; labelKey: string }[]
